<template>
    <BreadCrumb PageTitle="Liste des emplacement" />
    <ListeEmplacement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeEmplacement from "../../components/Emplacement/ListeEmplacement.vue";
    export default defineComponent({
      name: "ListeEmplacementPage",
      components: {
        BreadCrumb,
        ListeEmplacement,
      },
    });
  </script>